const getWording = (key, defaultTrad, lang, translateText) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (key?.[lang]?.length) {
    return translateText(key);
  }
  return defaultTrad;
};

export default getWording;
